import { useWarrantyLogsModalStore } from '../../model/use-warranty-logs-modal.store';
import { InlineSvg } from 'components/svg';

export const ModalHeader = () => {
  const { closeCreateModal } = useWarrantyLogsModalStore();
  return (
    <div className="modal-header p-0 pt-5 pe-5 justify-content-end">
      <h2 className="fw-bolder mx-7 my-5 w-100">New Warranty Item</h2>
      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-maintenance-task-action="close"
        onClick={() => closeCreateModal()}
        style={{ cursor: 'pointer' }}
      >
        <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};
